import { Mapper } from "../../../../base/utils/mapper";
import { TuningResponseModel } from "../../../../domain/models/consult/tuning-response.model";
import { TuningResponseEntity } from "../entities/tuning-response.entity";



export class TuningImplementationRepositoryMapper extends Mapper<TuningResponseEntity, TuningResponseModel> {
    mapFrom(param: TuningResponseEntity): TuningResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TuningResponseModel): TuningResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}